<template lang="pug">
v-app
  v-container.pa-0.ma-0(fluid home)
    v-layout(column)
      v-flex(align-center)
        v-img.home__logo-icon(src="/logo@40.png" width="40")
        .home__logo-title СУДЕБНЫЙ ПОРТАЛ
    
      v-flex(align-center grow)
        .home__content
          .home__content-title Универсальная платформа
          .home__content-title для судов и участников
          .home__content-title судопроизводства

          v-flex.mx-auto.my-7(xs5)
            .confirm-result {{text}}
               app-dialog-loading(v-model="loading")
          app-button-action(@click="showLoginDialog") Вход для участников

    login(v-model="dialogLogin")

</template>

<script>
import { AppDialogLoading } from '@/components'
import { userService } from '@/_services'
import login from './Login'

export default {
  name: 'confirm',
  components: {
    [AppDialogLoading.name]: AppDialogLoading,
    login
  },
  data() {
    return {
      loading: true,
      confirmText: '',
      dialogLogin: false,
    }
  },
  computed: {
    text() {
      return this.confirmText
    }
  },
  created() {
	userService.confirm(this.$route.params.uid, this.$route.params.code).then(status => {
      this.loading=false
      if (status) {
          this.confirmText = 'Успех! Аккаунт подтверждён, теперь вы можете авторизоваться.';
      } else {
          this.confirmText = 'Внимание! Во время подтверждения аккаунта произошла ошибка.';
      }
	})
  },
  methods: {
	showLoginDialog() {
      this.dialogLogin = true
	}
  },
}
</script>


<style lang="scss" scoped>
.home {
  font: normal 14px/24px $roboto;
  text-align: center;
}

.home__logo-icon {
  margin-top: 32px;
  margin-left: 84px;
}
.home__logo-title {
  margin-top: 8px;
  margin-left: 48px;
  font-family: $cond;
  color: #C4C4C4;
  text-align: left;
}
.home__content {
  margin-top: 130px;
}
.home__content-title {
  font-family: $slab;
  font-size: 24px;
}
.home__content-caption {
  margin: 40px auto;
}

.home__login {
  padding: 24px 0px 0px 0px;
}

.confirm-result {
  padding: 10px 20px;
  font-size: 16px;
  background-color:gray;
}
</style>